import { useMedplum } from '@medplum/react'
import { useMemo } from 'react'
import { createTanstackQueryUtils } from '@orpc/tanstack-query'
import { config } from '@/config'
import { createOrpcClient, type OrpcClient } from '@/orpc/client'
import { recoverAccessToken } from '@/auth/brokerSession'

export type { OrpcClient }

export function useClient() {
  const medplum = useMedplum()

  return useMemo(
    () =>
      createOrpcClient({
        baseUrl: config.middlewareUrl,
        getToken: () => medplum.getAccessToken(),
        recoverAuth: () => recoverAccessToken(medplum),
      }),
    [medplum],
  )
}

export function useOrpc() {
  const client = useClient()
  return useMemo(() => createTanstackQueryUtils(client), [client])
}
